export const POLLING_INTERVAL = 5000;

export const SWI_SNAP_HOST_AGENT = "SolarWinds Snap Agent";
export const APPOPTICS_INSTALLER_URL_BASE = "https://files.appoptics.com";
export const INSTALLER_URL_BASE = "https://files.solarwinds.cloud";

export { KB_URL_BASE } from "constants/externalUrls";

export const ONBOARDING_ROUTE = "/onboarding";
export const APM_ROUTE = `${ONBOARDING_ROUTE}/apm`;
export const AWS_ROUTE = `${ONBOARDING_ROUTE}/aws`;
export const HOST_ROUTE = `${ONBOARDING_ROUTE}/host`;
export const WELCOME_ROUTE = `${ONBOARDING_ROUTE}/welcome`;
export const WELCOME_SAM_ROUTE = `${ONBOARDING_ROUTE}/welcome/sam`;
export const SAMPLE_APP_ROUTE = `${APM_ROUTE}/sample`;

export const NONE = { none: true };
export const AGENT_TOKEN = "Default Agent Reporting Token (autogenerated)";

const { SLINGBOT_ACCOUNT_ID = "" } = window.Session || {};
export { SLINGBOT_ACCOUNT_ID };

export const POPULAR_AWS_REGION_IDS = [
  "ap-northeast-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "eu-central-1",
  "eu-west-1",
  "sa-east-1",
  "us-east-1",
  "us-west-1",
  "us-west-2",
];
